import React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import MobileNav from "./nav/mobile-nav"

const MobileHeader = ({ location, routeParams, toggleMobileNav }) => {
  return (
    <div className="mobile-header bg-primary">
      <div className="sticky top-0 left-0 z-20">
        <div className="w-full">
          <Link to={`/quote/`}>
            <div className="w-full flex justify-center font-bold get-a-quote qbutton">
              GET A QUOTE
            </div>
          </Link>
        </div>
        <div className="relative pt-3 px-7 bg-primary">
          <div className="flex flex-wrap justify-between w-full reds-border--none sm:reds-border--bottom pb-4">
            <div className="flex justify-center items-end">
              <Link to={`/${routeParams?.location}/`}>
                <StaticImage
                  width={116}
                  src="../../static/images/icon/redsoda-logo-light.svg"
                  alt="icon/redsoda-logo-light"
                  formats={["auto", "webp", "avif"]}
                />
              </Link>
            </div>
            <div className="flex flex-wrap items-center">
              <button onClick={toggleMobileNav} className="flex items-center">
                <StaticImage
                  src="../../../src/static/images/icon/close-icon.svg"
                  alt="icon/mobile-nav-icon"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="px-7">
        <MobileNav location={location} routeParams={routeParams} />
      </div>
    </div>
  )
}

export default MobileHeader
